module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_vm._m(0), _vm._v(" "), _c('events-calendar', {
    attrs: {
      "category": "rentals"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" Rentals by Month")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48fd8506"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/property/PropertyRentalMonth.vue
// module id = 1461
// module chunks = 0